<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
<div class="top-container background">
  @if (!hideTopbar) {
    <app-topbar
      [title]="topbarText"
      [topbarView]="TopbarView.BLUEPRINT_HOME"
      [imageFilePath]="topbarImage"
      (urlNavigate)="topBarNavigate($event)"
    ></app-topbar>
  }
  <div class="card-container">
    @for (msel of joinMselList; track msel) {
      <mat-card
        appearance="outlined"
        class="base-card"
        tabindex="0"
        >
        <mat-card-header>
          <mat-card-title>{{ msel.name }}</mat-card-title>
          <mat-card-subtitle>{{ msel.description }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <a
            mat-stroked-button
            [routerLink]="['/join']"
            [queryParams]="{ msel: msel.id }"
            title="Join {{ msel.name }}"
            >
            Join
          </a>
        </mat-card-actions>
      </mat-card>
    }
  </div>
  </div>
